export default "__VITE_ASSET__Br1kFWU2__"